import * as React from "react"
import { useState } from "react"
import Layout from "../components/layout"
import "../styles/main.scss"
import { InView } from "react-intersection-observer"
import { Fade } from "react-reveal"

// Assets
import MuteIcon from "../images/mute.svg"
import PlayIcon from "../images/play.svg"

// Components
import Header from "../components/header"
import About from "../components/about"
import Schedule from "../components/schedule"
import Ticket from "../components/ticket"
import GetTicketsPopUp from "../components/GetTicketsPopUp"
import Mission from "../components/Mission"

const IndexPage = () => {
  const [openPopUp, setOpenPopUp] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)
  const [openMission, setOpenMission] = useState(false)
  const [showGetTicketsPopUp, setShowGetTicketsPopUp] = useState(false)

  const sounds = [
    "https://storage.googleapis.com/loudbeta/songs/dawn/dawn-1615742021265-TB382.mp3",
    "https://storage.googleapis.com/loudbeta/Home%20Audio/JT%20-%20pink.mp3",
    "https://storage.googleapis.com/loudbeta/Home%20Audio/All%20my%20love-drenathan-1614528257709.mp3",
  ]

  function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  function toggleAudio() {
    const audioEl = document.getElementsByClassName("audio-element")[0]
    if (isPlaying) {
      audioEl.pause()
      setIsPlaying(false)
    } else {
      audioEl.play()
      setIsPlaying(true)
    }
  }

  return (
    <Layout
      btnClick={() => setOpenPopUp(!openPopUp)}
      audioBtn={toggleAudio}
      isPlaying={isPlaying}
      setOpenMission={setOpenMission}
    >
      {showGetTicketsPopUp && (
        <Fade bottom>
          <div className="cta-btns">
            <button onClick={() => setOpenPopUp(true)}>Get Tickets</button>
            <button onClick={() => toggleAudio()}>
              <img src={isPlaying ? MuteIcon : PlayIcon}></img>
            </button>
          </div>
        </Fade>
      )}
      <InView
        as="div"
        onChange={(inView, entry) => {
          if (inView) {
            setShowGetTicketsPopUp(false)
          }
        }}
      >
        <Header
          getTickets={() => setOpenPopUp(true)}
          isPlaying={isPlaying}
          audioBtn={toggleAudio}
        ></Header>
      </InView>

      <About></About>

      <InView
        as="div"
        onChange={(inView, entry) => {
          if (inView) {
            setShowGetTicketsPopUp(true)
          }
        }}
      >
        <Schedule></Schedule>
      </InView>
      <Ticket btnClick={() => setOpenPopUp(!openPopUp)}></Ticket>
      {openPopUp && (
        <GetTicketsPopUp closeBtn={() => setOpenPopUp(false)}></GetTicketsPopUp>
      )}
      <audio className="audio-element">
        <source src={sounds[randomInteger(0, 2)]}></source>
      </audio>
      {openMission && <Mission setOpenMission={setOpenMission}></Mission>}
    </Layout>
  )
}

export default IndexPage
